import { combineReducers } from 'redux';
import { reducer as createReducer } from './createModule';

export default combineReducers({
	create: createReducer,
});
